import React from "react";

import classNames from "classnames";

import Button from "ui/Button";
import Dropdown from "ui/Dropdown";
import { ConfigIcon } from "ui/Icons";

type Props = {
  className?: string;
  columns: readonly Column[];
  hiddenFields: ReadonlySet<string>;
  onToggleHidden: (field: string) => void;
};

export type Column = {
  header?: React.ReactNode;
  field: string;
};

function ColumnSettingsMenu({
  className,
  columns,
  hiddenFields,
  onToggleHidden,
}: Props) {
  return (
    <Dropdown
      className={classNames(className, "[&>div]:rounded-b")}
      trigger={({ toggleOpen }) => (
        <Button bare aria-label="Configure columns" onClick={toggleOpen}>
          <ConfigIcon className="!text-link hover:!text-link-hover text-base" />
        </Button>
      )}
    >
      {() => (
        <MenuBody
          columns={columns}
          hiddenFields={hiddenFields}
          onToggleHidden={onToggleHidden}
        />
      )}
    </Dropdown>
  );
}

function MenuBody({ columns, hiddenFields, onToggleHidden }: Props) {
  const isLastVisibleColumn = columns.length - hiddenFields.size <= 1;
  return (
    <div className="p-2 pt-1 text-[#606060] min-w-52">
      <div className="!text-sm text-left mb-2 normal-case">Show columns:</div>
      <ul className="list-none p-0 m-0 ml-2">
        {columns.map((col) => {
          const field = col.field;
          const checked = !hiddenFields.has(field);
          const disabled = checked && isLastVisibleColumn;
          return (
            <li key={field}>
              <label className="flex items-center gap-2 cursor-pointer uppercase !font-medium text-xs">
                <input
                  type="checkbox"
                  checked={checked}
                  disabled={disabled}
                  title={
                    disabled
                      ? "At least one column must remain visible"
                      : undefined
                  }
                  onChange={() => onToggleHidden(field)}
                />
                <span>{col.header ?? field}</span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default ColumnSettingsMenu;
